import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { advanceParamCheck } from '../../utils';

export interface ExitMiniProgramOptions extends Partial<GeneralInvokeOption> {
  invalidParamObj?: any;
}

const optionalParam = { optional: true }; // 可选参数

export function exitMiniProgram(option: ExitMiniProgramOptions) {
  if (
    advanceParamCheck(
      APINames.Native.EXIT_MINI_PROGRAM,
      option,
      { clearCache: false },
      { clearCache: optionalParam }
    )
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.EXIT_MINI_PROGRAM,
      option
    );
  }
  return option.invalidParamObj;
}
